import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Text from "src/components/Displays/Text";
import { SESSION_KEYS } from "src/consts/session";
import { SMART_CHARGING_ROUTES } from "src/consts/routes";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { authenticationCallback } from "src/api/smartChargingClients";

const AuthenticationCallback = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const [getCustomerAccess] = useSessionStorage<string>(
    SESSION_KEYS.MFE_CUSTOMER_ACCESS,
  );

  const initialCall = useCallback(async () => {
    const customerAccess = getCustomerAccess();
    if (!customerAccess) return;
    try {
      const response = await authenticationCallback({
        xIsonCustomerToken: customerAccess,
        searchParams: window.location.search,
      });

      setTimeout(() => {
        if (response.msgId === "success") {
          navigate(
            SMART_CHARGING_ROUTES.ADD_EV_SUCCESS +
              `?manufacturer=${response.data.manufacturer}&model=${response.data.model}`,
          );
        } else {
          navigate(SMART_CHARGING_ROUTES.ADD_EV_FAILED);
        }
      }, 1000);
    } catch (e) {
      const error = e as Error;
      navigate(SMART_CHARGING_ROUTES.ADD_EV_FAILED + `?msgId=${error.msgId}`);
    }
  }, [getCustomerAccess, navigate]);

  useEffect(() => {
    initialCall();
  }, [initialCall]);

  return (
    <Stack gap={5}>
      <Text
        text={t("page.addEvStart.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.addEvStart.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Box>
        <PrimaryButton
          isLoading={true}
          text={t("page.addEvStart.nextBtnText")}
        />
      </Box>
    </Stack>
  );
};

export default AuthenticationCallback;
